import React, { SVGAttributes } from 'react';

interface Props extends SVGAttributes<SVGSVGElement> {
  color?: string;
}

export default function OcOk({ color = 'white', ...rest }: Props) {
  return (
    <svg
      width="117"
      height="112"
      viewBox="0 0 117 112"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M79.4817 62.9553C88.7946 66.3582 99.3633 78.0184 71.7383 94.9357"
        stroke={color}
        strokeWidth="0.978456"
        strokeLinecap="round"
      />
      <path
        d="M56.4611 61.3928C50.1828 60.5594 33.6373 64.3094 42.0207 81.2891C43.0324 83.3378 46.7087 87.3728 53.3219 87.1228C61.7977 86.8023 66.367 95.3176 69.1225 99.415"
        stroke={color}
        strokeWidth="0.978456"
        strokeLinecap="round"
      />
      <path
        d="M53.7734 68.0261C59.5543 72.3567 70.7758 86.4452 69.4138 108.155C68.0521 129.864 67.9243 132.846 68.0308 131.624"
        stroke={color}
        strokeWidth="0.978456"
        strokeLinecap="round"
      />
      <path
        d="M61.9648 90.9885V108.895"
        stroke={color}
        strokeWidth="0.978456"
        strokeLinecap="round"
      />
      <path
        d="M75.4082 93.0952V110.159"
        stroke={color}
        strokeWidth="0.978456"
        strokeLinecap="round"
      />
      <path
        d="M71.6289 94.7805C72.0139 88.8499 74.1075 72.7108 79.4009 55.5972"
        stroke={color}
        strokeWidth="0.978456"
        strokeLinecap="round"
      />
      <path
        d="M60.28 74.1354C60.3525 71.0905 59.5633 63.9296 55.8275 59.6458C51.1578 54.2909 50.832 51.036 50.832 41.0613"
        stroke={color}
        strokeWidth="0.978456"
        strokeLinecap="round"
      />
      <path
        d="M62.1752 44.0106C60.4181 43.7066 57.4312 41.68 59.5397 36.0054"
        stroke={color}
        strokeWidth="0.978456"
        strokeLinecap="round"
      />
      <path
        d="M87.3261 35.1987C87.2597 36.2354 86.5898 38.3502 84.4414 38.516"
        stroke={color}
        strokeWidth="0.978456"
        strokeLinecap="round"
      />
      <path
        d="M84.4414 44.0107C88.42 41.6955 94.8059 36.0076 88.5196 31.7779C87.6575 31.1558 85.6349 30.7827 84.4414 34.2658"
        stroke={color}
        strokeWidth="0.978456"
        strokeLinecap="round"
      />
      <path
        d="M74.9884 28.8429C74.1984 28.525 72.1682 28.0799 70.3672 28.8429"
        stroke={color}
        strokeWidth="0.978456"
        strokeLinecap="round"
      />
      <path
        d="M56.2934 29.8961C55.36 29.5783 52.9605 29.1331 50.832 29.8961"
        stroke={color}
        strokeWidth="0.978456"
        strokeLinecap="round"
      />
      <path
        d="M81.0617 5.30973C104.582 7.76608 97.3955 25.6734 90.862 34.3201C89.5273 31.3555 86.9002 31.2497 85.7533 31.5672C84.669 14.881 74.3196 17.1327 69.2804 20.3443C58.7712 19.9208 56.1439 24.1206 56.1439 26.2734C51.5886 23.3875 47.731 26.7756 47.4182 27.5167C35.7413 -7.04148 65.0754 -1.57228 81.0617 5.30973Z"
        fill={color}
      />
      <path
        d="M71.838 40.324C67.7197 40.324 64.3811 36.9758 64.3811 32.8455C64.3811 28.7152 67.7197 25.3669 71.838 25.3669C75.9563 25.3669 79.2949 28.7152 79.2949 32.8455C79.2949 36.9758 75.9563 40.324 71.838 40.324Z"
        stroke={color}
        strokeWidth="0.978456"
      />
      <path
        d="M72.154 36.4266C71.1679 36.4266 70.3685 35.4363 70.3685 34.2146C70.3685 32.993 71.1679 32.0027 72.154 32.0027C73.1401 32.0027 73.9395 32.993 73.9395 34.2146C73.9395 35.4363 73.1401 36.4266 72.154 36.4266Z"
        fill={color}
      />
      <path
        d="M45.2656 32.8455C45.2656 36.9692 48.6448 40.324 52.8276 40.324C57.0104 40.324 60.3895 36.9692 60.3895 32.8455C60.3895 28.7215 57.0104 25.3669 52.8276 25.3669C48.6448 25.3669 45.2656 28.7215 45.2656 32.8455Z"
        stroke={color}
        strokeWidth="0.978456"
      />
      <path
        d="M52.6187 36.4266C51.4006 36.4266 50.4131 35.4363 50.4131 34.2146C50.4131 32.993 51.4006 32.0027 52.6187 32.0027C53.8368 32.0027 54.8242 32.993 54.8242 34.2146C54.8242 35.4363 53.8368 36.4266 52.6187 36.4266Z"
        fill={color}
      />
      <path
        d="M60.2852 32.8455H64.2762"
        stroke={color}
        strokeWidth="0.978456"
        strokeLinecap="round"
      />
      <path
        d="M79.4004 31.7922L84.8618 33.0562"
        stroke={color}
        strokeWidth="0.978456"
        strokeLinecap="round"
      />
      <path
        d="M88.8516 70.3435C112.011 83.2736 136.76 117.102 89.37 160.086"
        stroke={color}
        strokeWidth="0.978456"
        strokeLinecap="round"
      />
      <path
        d="M30.248 94.1484C37.6699 117.231 30.5661 135.927 41.3809 156.294"
        stroke={color}
        strokeWidth="0.978456"
        strokeLinecap="round"
      />
      <path
        d="M17.758 129.583C24.2812 128.731 28.9676 115.112 28.091 104.525C27.5709 98.2422 27.3304 90.9227 28.0631 85.709C25.3034 73.9763 19.1672 74.6875 16.4441 76.5097C7.21778 87.5312 5.60809 105.595 7.09817 113.634C7.93347 119.305 11.2348 130.434 17.758 129.583Z"
        stroke={color}
        strokeWidth="0.978456"
        strokeLinecap="round"
      />
      <path
        d="M58.8145 50.6621C60.0397 52.0664 63.5407 54.0327 67.7417 50.6621"
        stroke={color}
        strokeWidth="0.978456"
        strokeLinecap="round"
      />
      <path
        d="M29.1985 53.5073C29.2347 53.9419 29.0994 54.5333 28.5684 54.8655"
        stroke={color}
        strokeWidth="0.978456"
        strokeLinecap="round"
      />
      <path
        d="M28.5676 54.8654C28.0884 55.1652 27.2869 55.2541 25.9978 54.8264C25.8944 54.7921 25.7814 54.7952 25.685 54.8458C24.4656 55.4856 22.8201 57.3133 24.9967 60.1431C27.8324 63.8297 29.3028 58.1195 28.5676 54.8654Z"
        stroke={color}
        strokeWidth="0.978456"
        strokeLinecap="round"
      />
      <path
        d="M13.395 53.5073C12.5383 51.2954 10.8957 45.6001 13.395 44.8701C16.6997 43.9053 15.9651 54.982 17.4355 53.5073C18.9059 52.0327 15.9651 39.7089 19.9561 41.1835C22.7299 42.2084 22.1638 48.0244 21.3019 51.9044C21.2072 52.3306 21.8208 52.7136 22.1917 52.485C23.9772 51.3845 26.7302 50.7715 29.1985 53.5073C30.3889 53.1913 32.6854 53.5284 32.3493 57.4046C32.0132 61.2808 29.4785 65.6906 28.2533 67.4111C26.923 69.0612 24.3673 72.9937 24.7874 75.5216"
        stroke={color}
        strokeWidth="0.978456"
        strokeLinecap="round"
      />
      <path
        d="M16.5947 74.679C17.0848 73.6961 17.645 71.1188 15.9646 68.6751C13.864 65.6205 6.40712 51.1901 10.3981 50.1367C12.0779 49.9092 12.4196 51.7315 13.3944 53.5074C13.872 54.3774 14.1784 55.2811 14.9136 56.4398"
        stroke={color}
        strokeWidth="0.978456"
        strokeLinecap="round"
      />
      <path
        d="M28.041 85.6165C28.7063 84.1067 34.3426 72.0919 40.2241 68.9741"
        stroke={color}
        strokeWidth="0.978456"
        strokeLinecap="round"
      />
    </svg>
  );
}
